var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.5C6.84315 2.5 5.5 3.84315 5.5 5.5C5.5 7.15685 6.84315 8.5 8.5 8.5C10.1569 8.5 11.5 7.15685 11.5 5.5C11.5 3.84315 10.1569 2.5 8.5 2.5ZM3.5 5.5C3.5 2.73858 5.73858 0.5 8.5 0.5C11.2614 0.5 13.5 2.73858 13.5 5.5C13.5 8.26142 11.2614 10.5 8.5 10.5C5.73858 10.5 3.5 8.26142 3.5 5.5ZM0.5 17.5C0.5 14.7386 2.73858 12.5 5.5 12.5H11.5C14.2614 12.5 16.5 14.7386 16.5 17.5V20.5C16.5 21.0523 16.0523 21.5 15.5 21.5C14.9477 21.5 14.5 21.0523 14.5 20.5V17.5C14.5 15.8431 13.1569 14.5 11.5 14.5H5.5C3.84315 14.5 2.5 15.8431 2.5 17.5V20.5C2.5 21.0523 2.05228 21.5 1.5 21.5C0.947715 21.5 0.5 21.0523 0.5 20.5V17.5ZM22.5 4.5C23.0523 4.5 23.5 4.94772 23.5 5.5V8.5H26.5C27.0523 8.5 27.5 8.94772 27.5 9.5C27.5 10.0523 27.0523 10.5 26.5 10.5H23.5V13.5C23.5 14.0523 23.0523 14.5 22.5 14.5C21.9477 14.5 21.5 14.0523 21.5 13.5V10.5H18.5C17.9477 10.5 17.5 10.0523 17.5 9.5C17.5 8.94772 17.9477 8.5 18.5 8.5H21.5V5.5C21.5 4.94772 21.9477 4.5 22.5 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmployee);
export default __webpack_public_path__ + "static/media/add_employee.b0b82b52873c388eba5e8bfb17144a15.svg";
export { ForwardRef as ReactComponent };